import { FilterToolbarGroup, SelectedFilters } from 'src/components/Filters';
import { Content } from 'src/contexts/ContentContext';
import { useMobileDrawerContext } from 'src/contexts/MobileDrawerContext';
import { Button, Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

import { InventoryAllFilterContent } from '../InventoryAllFiltersContent';

export const ActionToAllFilters = ({
  hasFilters = false,
  selectedFilters,
  filters,
  onSaveSelectedFilters,
}: {
  selectedFilters: SelectedFilters;
  filters: FilterToolbarGroup[];
  onSaveSelectedFilters: (_: SelectedFilters) => void;
  hasFilters?: boolean;
}) => {
  const { openWithContent, close } = useMobileDrawerContext();

  return (
    <Stack width="full" alignItems="center" justifyContent="center">
      <Button
        variant={hasFilters ? 'outlineGray' : 'text'}
        style={{ width: '100%' }}
        onClick={() =>
          openWithContent(
            <InventoryAllFilterContent
              filters={filters}
              selectedFilters={selectedFilters}
              setSelectedFilters={onSaveSelectedFilters}
              onClose={close}
            />,
            { position: 'bottom', size: '95%' }
          )
        }
      >
        <Content
          id={hasFilters ? ContentId.AddFilter : ContentId.ViewAllFilters}
        />
      </Button>
    </Stack>
  );
};
